import React from "react";

/**
 * Reusable Coin Packages Icon Component
 * Currency circle SVG icon with dynamic stroke weight based on active state
 */
const CoinPackagesIcon = ({
  className = "w-7 h-7",
  isActive = false,
  ...props
}) => {
  // Generate unique gradient ID to avoid conflicts when multiple instances are rendered
  const gradientId = `primaryGradientCoinPackages-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${className} flex-shrink-0`}
      {...props}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFE48A" />
          <stop offset="50%" stopColor="var(--color-primary)" />
          <stop offset="100%" stopColor="#A87A1F" />
        </linearGradient>
      </defs>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={isActive ? "2" : "1.5"}
        stroke={`url(#${gradientId})`}
        d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      />
    </svg>
  );
};

export default CoinPackagesIcon;
